import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const FormatPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "FormatPage" */ './Container'),
  'page'
);
